/**
 * Tier buybox — replaces the Skio plan picker UI with a Buy Once / Subscribe & Save
 * widget with 1 / 3 / 6 month tier cards (the winning Convert "buybox" variation, made native).
 * Config is read from <script type="application/json" data-tier-buybox-config>, rendered by
 * snippets/tier-buybox.liquid. Bails out (leaving the stock picker) when the product does not have
 * at least two of the 1 / 3 / 6 month Skio plans.
 *
 * Coexists with the legacy Convert test script (`cvt-` classes): whichever renders first wins and
 * the other treats the picker as already handled, so the widget can never render twice.
 */
(function () {
  // a per-template section config (data-override) wins over the global one if both are on the page
  var configEl = document.querySelector('script[data-tier-buybox-config][data-override="true"]') ||
    document.querySelector('script[data-tier-buybox-config]');
  if (!configEl) return;
  if (window.__tierBuyboxLoaded) return; // script included twice (e.g. snippet + section)
  window.__tierBuyboxLoaded = true;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    console.warn('[tier-buybox] invalid config JSON', e);
    return;
  }

  function warn(reason, detail) {
    if (window.console && console.warn) console.warn('[tier-buybox] not rendered: ' + reason, detail || '');
    return false;
  }

  var TIER_ORDER = [1, 3, 6];
  var WATCH_TIMEOUT = 5000;

  function toNumber(value) {
    var n = parseFloat(value);
    return isNaN(n) ? 0 : n;
  }

  function formatMoney(cents) {
    var amount = Math.round(toNumber(cents));
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(amount);
    }
    return '$' + (amount / 100).toFixed(2);
  }

  function shortMoney(cents) {
    return formatMoney(cents).replace(/\.00$/, '');
  }

  function getOrCreateInput(form, name) {
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    return input;
  }

  function syncQuantityInputs(form, value) {
    var inputs = form.querySelectorAll('input[name="quantity"]');
    for (var i = 0; i < inputs.length; i += 1) {
      inputs[i].value = String(value);
      inputs[i].setAttribute('value', String(value));
      inputs[i].dispatchEvent(new Event('input', { bubbles: true }));
      inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function getTierForPlan(plan) {
    var optionValue = plan && plan.options && plan.options[0] ? String(plan.options[0].value || '') : '';
    var haystack = (optionValue + ' ' + (plan && plan.name ? plan.name : '')).toLowerCase();
    if (/1\s*month|30\s*day/.test(haystack) && !/[2456]\s*month/.test(haystack)) return 1;
    if (/3\s*month|90\s*day/.test(haystack)) return 3;
    if (/6\s*month|180\s*day/.test(haystack)) return 6;
    return null;
  }

  function onceDiscount(qty) {
    return toNumber(config.onceDiscounts && config.onceDiscounts[qty]);
  }

  function getOnceNote(qty) {
    var off = onceDiscount(qty);
    return off > 0 ? 'Save ' + shortMoney(off) + ' when you buy' : 'Full Price';
  }

  function getReceiveCopy(qty) {
    return 'Receive ' + qty + (qty === 1 ? ' tube every ' : ' tubes every ') + qty + (qty === 1 ? ' month' : ' months');
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  // state of the widget currently on the page (null when the stock picker is showing)
  var active = null;

  function findForm() {
    var scope = document.querySelector('#product-template');
    return (scope && scope.querySelector('form[action*="/cart/add"]')) || document.querySelector('form[action*="/cart/add"]');
  }

  // Remove the widget and put the stock Skio picker / buy buttons back.
  function teardown() {
    if (!active) return;
    if (active.buybox.parentNode) active.buybox.parentNode.removeChild(active.buybox);
    if (active.fieldset) {
      active.fieldset.style.display = '';
      active.fieldset.removeAttribute('data-tier-buybox-rendered');
      active.fieldset.removeAttribute('data-cvt-rendered');
    }
    document.body.classList.remove('tier-buybox-active');
    if (active.stockButtons) active.stockButtons.style.display = '';
    var planInput = active.form.querySelector('input[name="selling_plan"]');
    if (planInput) planInput.value = '';
    active = null;
  }

  // restore: optional { subscribed, tierQty } carried over from the previous variant's widget
  function init(restore) {
    var fieldset = document.querySelector('fieldset[skio-plan-picker]');
    if (!fieldset) return false; // may not exist yet; retried by the observer
    // already handled by us or by the legacy Convert variation
    if (fieldset.getAttribute('data-tier-buybox-rendered') === 'true' ||
        fieldset.getAttribute('data-cvt-rendered') === 'true' ||
        document.querySelector('.cvt-buybox')) return true;

    var productScript = fieldset.querySelector('script[type="text/json"][skio-product-json]');
    if (!productScript) return warn('no skio-product-json in picker');

    var product;
    try {
      product = JSON.parse(productScript.textContent || productScript.innerHTML || '');
    } catch (e) {
      return warn('product JSON parse failed', e);
    }

    var form = findForm();
    if (!form) return warn('no /cart/add form found');

    var variants = product.variants || [];
    var variantIdInput = form.querySelector('input[name="id"]');
    var variant = null;
    var i;
    var j;
    for (i = 0; i < variants.length; i += 1) {
      if (variantIdInput && String(variants[i].id) === String(variantIdInput.value)) {
        variant = variants[i];
        break;
      }
    }
    if (!variant) variant = variants[0];
    if (!variant) return warn('no variant');

    // Map selling plans to 1 / 3 / 6 month tiers
    var plansById = {};
    var groups = product.selling_plan_groups || [];
    for (i = 0; i < groups.length; i += 1) {
      var group = groups[i];
      if (!group || (group.name !== 'Subscription' && group.name !== 'Prepaid')) continue;
      for (j = 0; j < (group.selling_plans || []).length; j += 1) {
        var plan = group.selling_plans[j];
        var planQty = getTierForPlan(plan);
        if (planQty && !plansById[String(plan.id)]) plansById[String(plan.id)] = { id: plan.id, qty: planQty };
      }
    }

    var tiers = {};
    var allocations = variant.selling_plan_allocations || [];
    for (i = 0; i < allocations.length; i += 1) {
      var allocation = allocations[i];
      var planId = allocation.selling_plan_id || (allocation.selling_plan && allocation.selling_plan.id);
      var match = plansById[String(planId)];
      if (match && !tiers[match.qty]) tiers[match.qty] = { id: match.id, qty: match.qty, allocation: allocation };
    }

    var availableTiers = [];
    for (i = 0; i < TIER_ORDER.length; i += 1) {
      if (tiers[TIER_ORDER[i]]) availableTiers.push(tiers[TIER_ORDER[i]]);
    }
    if (availableTiers.length < 2) {
      return warn('need at least 2 of the 1/3/6 month plans on the selected variant', {
        groups: groups.map(function (g) { return g.name + ': ' + (g.selling_plans || []).map(function (p) { return p.name; }).join(' / '); }),
        allocations: allocations.length
      });
    }

    var sellingPlanInput = getOrCreateInput(form, 'selling_plan');
    var quantityInput = getOrCreateInput(form, 'quantity');
    var discountProp = form.querySelector('[name="properties[Discount]"]');
    var subscribed = true;

    var buybox = el('div', 'tier-buybox');
    var grid = el('div', 'tier-buybox__grid');

    // --- Buy Once option ---
    var onceOption = el('div', 'tier-buybox__option tier-buybox__option--once');
    var onceHead = el('div', 'tier-buybox__head');
    var onceRadio = el('div', 'tier-buybox__radio');
    onceRadio.setAttribute('role', 'radio');
    onceRadio.setAttribute('tabindex', '0');
    onceRadio.setAttribute('aria-checked', 'false');
    onceRadio.setAttribute('aria-label', config.onceTitle);
    var onceTitles = el('div');
    onceTitles.appendChild(el('div', 'tier-buybox__title', config.onceTitle));
    onceTitles.appendChild(el('div', 'tier-buybox__sub', config.onceSubtitle));
    onceHead.appendChild(onceRadio);
    onceHead.appendChild(onceTitles);
    onceOption.appendChild(onceHead);
    buybox.appendChild(onceOption);

    // --- Subscribe option ---
    var subOption = el('div', 'tier-buybox__option tier-buybox__option--sub');
    var subHead = el('div', 'tier-buybox__head');
    var subRadio = el('div', 'tier-buybox__radio');
    subRadio.setAttribute('role', 'radio');
    subRadio.setAttribute('tabindex', '0');
    subRadio.setAttribute('aria-checked', 'true');
    subRadio.setAttribute('aria-label', config.subscribeTitle);
    var subTitles = el('div');
    subTitles.appendChild(el('div', 'tier-buybox__title', config.subscribeTitle));
    var list = el('ul', 'tier-buybox__list');
    var receiveItem = el('li');
    list.appendChild(receiveItem);
    (config.benefits || []).forEach(function (text) {
      if (text) list.appendChild(el('li', '', text));
    });
    subTitles.appendChild(list);
    subHead.appendChild(subRadio);
    subHead.appendChild(subTitles);
    subOption.appendChild(subHead);
    buybox.appendChild(subOption);

    // --- Quantity + Add to cart ---
    var atcRow = el('div', 'tier-buybox__atc-row');
    var qtyWrap = el('div', 'tier-buybox__qty');
    qtyWrap.appendChild(el('div', 'tier-buybox__qty-label', 'Quantity'));
    var qtyBox = el('div', 'tier-buybox__qty-box');
    var qtyMinus = el('button', 'tier-buybox__qty-btn', '−');
    qtyMinus.type = 'button';
    qtyMinus.setAttribute('aria-label', 'Decrease quantity');
    var qtyValue = el('span', 'tier-buybox__qty-value', '1');
    var qtyPlus = el('button', 'tier-buybox__qty-btn', '+');
    qtyPlus.type = 'button';
    qtyPlus.setAttribute('aria-label', 'Increase quantity');
    qtyBox.appendChild(qtyMinus);
    qtyBox.appendChild(qtyValue);
    qtyBox.appendChild(qtyPlus);
    qtyWrap.appendChild(qtyBox);
    atcRow.appendChild(qtyWrap);

    var addToCart = el('button', 'tier-buybox__atc', config.addToCartText);
    addToCart.type = 'button';
    atcRow.appendChild(addToCart);
    buybox.appendChild(atcRow);

    function setQty(value) {
      var next = Math.max(1, Math.round(toNumber(value)) || 1);
      qtyValue.textContent = String(next);
      quantityInput.value = String(next);
      quantityInput.setAttribute('value', String(next));
      qtyMinus.disabled = next <= 1;
      syncQuantityInputs(form, next);

      // keep any quantity-break radios on the page in sync
      var breaks = document.querySelectorAll('[name="product-qty-breaks"]');
      for (var b = 0; b < breaks.length; b += 1) {
        var isMatch = String(breaks[b].getAttribute('data-qty')) === String(next);
        breaks[b].checked = isMatch;
        var wrap = breaks[b].closest('.form-check');
        if (wrap) wrap.classList.toggle('form-check-is-checked', isMatch);
      }
    }

    function renderPrices() {
      var cards = grid.querySelectorAll('.tier-buybox__card');
      for (var c = 0; c < cards.length; c += 1) {
        var card = cards[c];
        var qty = Math.max(1, toNumber(card.getAttribute('data-qty')));
        var unitSub = toNumber(card.getAttribute('data-unit-sub'));
        var unitOnce = toNumber(card.getAttribute('data-unit-once'));
        var was = unitOnce * qty;
        var now = subscribed ? unitSub * qty : was - onceDiscount(qty);
        card.querySelector('.tier-buybox__now').textContent = formatMoney(now);
        var wasEl = card.querySelector('.tier-buybox__was');
        if (was > now) {
          wasEl.textContent = formatMoney(was);
          wasEl.style.display = '';
        } else {
          wasEl.style.display = 'none';
        }
      }
    }

    function setMode(next) {
      subscribed = !!next;
      onceOption.className = 'tier-buybox__option tier-buybox__option--once' + (subscribed ? '' : ' is-active');
      subOption.className = 'tier-buybox__option tier-buybox__option--sub' + (subscribed ? ' is-active' : '');
      onceRadio.setAttribute('aria-checked', subscribed ? 'false' : 'true');
      subRadio.setAttribute('aria-checked', subscribed ? 'true' : 'false');
      (subscribed ? subOption : onceOption).appendChild(grid);

      var active = grid.querySelector('.tier-buybox__card.is-active');
      if (active) {
        sellingPlanInput.value = subscribed ? active.getAttribute('data-selling-plan-id') : '';
        if (subscribed) receiveItem.textContent = active.getAttribute('data-receive-copy');
      }
      var cards = grid.querySelectorAll('.tier-buybox__card');
      for (var c = 0; c < cards.length; c += 1) {
        cards[c].querySelector('.tier-buybox__label').textContent = cards[c].getAttribute(subscribed ? 'data-label-sub' : 'data-label-once');
        var note = cards[c].querySelector('.tier-buybox__note');
        note.textContent = cards[c].getAttribute('data-once-note');
        note.style.display = subscribed ? 'none' : '';
      }
      if (discountProp) discountProp.disabled = !subscribed;
      renderPrices();
    }

    function bindOption(optionEl, wantSubscribed) {
      optionEl.addEventListener('click', function (event) {
        if (event.target.closest('.tier-buybox__grid')) return;
        setMode(wantSubscribed);
      });
      optionEl.querySelector('.tier-buybox__radio').addEventListener('keydown', function (event) {
        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          setMode(wantSubscribed);
        }
      });
    }
    bindOption(onceOption, false);
    bindOption(subOption, true);

    qtyMinus.addEventListener('click', function () { setQty(toNumber(qtyValue.textContent) - 1); });
    qtyPlus.addEventListener('click', function () { setQty(toNumber(qtyValue.textContent) + 1); });

    addToCart.addEventListener('click', function () {
      syncQuantityInputs(form, toNumber(qtyValue.textContent));
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    });

    // --- Tier cards ---
    availableTiers.forEach(function (tier) {
      var months = tier.qty + ' ' + (tier.qty === 1 ? 'Month' : 'Months');
      var card = el('button', 'tier-buybox__card');
      card.type = 'button';
      card.setAttribute('aria-pressed', 'false');
      card.setAttribute('data-selling-plan-id', String(tier.id));
      card.setAttribute('data-qty', String(tier.qty));
      card.setAttribute('data-unit-sub', String(toNumber(tier.allocation.price)));
      card.setAttribute('data-unit-once', String(toNumber(variant.price)));
      card.setAttribute('data-receive-copy', getReceiveCopy(tier.qty));
      card.setAttribute('data-once-note', getOnceNote(tier.qty));
      card.setAttribute('data-label-sub', months);
      card.setAttribute('data-label-once', tier.qty + (tier.qty === 1 ? ' Tube' : ' Tubes'));

      // tier image only when one is configured; otherwise the card is text-only (no product-media fallback)
      var imageUrl = (config.images && config.images[tier.qty]) || '';
      if (imageUrl) {
        var img = el('img', 'tier-buybox__img');
        img.src = imageUrl;
        img.alt = months + ' supply';
        img.loading = 'lazy';
        card.appendChild(img);
      }
      var note = el('div', 'tier-buybox__note');
      note.style.display = 'none';
      card.appendChild(note);
      card.appendChild(el('div', 'tier-buybox__label', months));
      var price = el('div', 'tier-buybox__price');
      price.appendChild(el('span', 'tier-buybox__now'));
      price.appendChild(el('span', 'tier-buybox__was'));
      card.appendChild(price);

      card.addEventListener('click', function () {
        var cards = grid.querySelectorAll('.tier-buybox__card');
        for (var k = 0; k < cards.length; k += 1) {
          cards[k].classList.remove('is-active');
          cards[k].setAttribute('aria-pressed', 'false');
        }
        card.classList.add('is-active');
        card.setAttribute('aria-pressed', 'true');
        setQty(card.getAttribute('data-qty'));
        setMode(subscribed);
      });
      grid.appendChild(card);
    });

    // Replace the stock Skio picker and buy buttons
    fieldset.style.display = 'none';
    fieldset.setAttribute('data-tier-buybox-rendered', 'true');
    fieldset.setAttribute('data-cvt-rendered', 'true'); // tells the legacy Convert script not to render a second widget
    fieldset.parentNode.insertBefore(buybox, fieldset.nextSibling);
    document.body.classList.add('tier-buybox-active');
    var stockButtons = form.querySelector('.product-buy-buttons');
    if (stockButtons) stockButtons.style.display = 'none';

    active = {
      buybox: buybox,
      fieldset: fieldset,
      form: form,
      stockButtons: stockButtons,
      getState: function () {
        var chosen = grid.querySelector('.tier-buybox__card.is-active');
        return { subscribed: subscribed, tierQty: chosen ? toNumber(chosen.getAttribute('data-qty')) : 0 };
      }
    };

    var defaultTier = (restore && tiers[restore.tierQty]) || tiers[config.defaultTier] || availableTiers[0];
    grid.querySelector('[data-qty="' + defaultTier.qty + '"]').click();
    if (restore && !restore.subscribed) setMode(false);
    // release the Convert anti-flicker hold if the test snippet is on the page
    if (typeof window.__cvtRevealBuybox === 'function') window.__cvtRevealBuybox();
    return true;
  }

  // Re-evaluate eligibility for the newly selected variant: rebuild the widget (keeping the shopper's
  // mode / tier where possible) or fall back to the stock picker if the variant has no 1/3/6 plans.
  function refresh() {
    var saved = active ? active.getState() : null;
    teardown();
    init(saved);
  }

  // Themes / Skio change the variant by setting input[name=id] programmatically (no event), and Skio may
  // re-render its picker, so watch the value and the fieldset instead of relying on a change event.
  function watchVariant() {
    var form = findForm();
    var lastId = '';
    if (form) {
      var first = form.querySelector('input[name="id"]');
      lastId = first ? String(first.value) : '';
    }
    function check() {
      var f = findForm();
      if (!f) return;
      var input = f.querySelector('input[name="id"]');
      var id = input ? String(input.value) : '';
      var orphaned = active && !document.body.contains(active.fieldset);
      if (id !== lastId || orphaned) {
        lastId = id;
        refresh();
      }
    }
    document.addEventListener('change', check, true);
    setInterval(check, 400);
  }

  function start() {
    watchVariant();
    if (init()) return;
    if (typeof MutationObserver !== 'function') return;
    var observer = new MutationObserver(function () {
      if (init()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, WATCH_TIMEOUT);
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
